export default __webpack_public_path__ + "static/media/reporthelp-export-mobile.6705dfd1.PNG";